<eds-banner-standard
  *ngIf="articleHubInfo"
  theme="primary"
  edsSpacing="xxl"
  [breadcrumbItems]="breadcrumbItems"
  [preTitle]="articleHubInfo.preTitle"
  [title]="articleHubInfo.title"
  [wide]="true"
>
</eds-banner-standard>

<section edsGrid edsSpacing="xxl" *ngIf="articleHubInfo">
  <div class="container container--wide">
    <div edsSpacing="xl" edsRow edsFlexbox justifyContent="space-between">
      <div
        edsCol
        edsSubGrid="layout-3"
        edsSubGridTablet="layout-3"
        edsSubGridGap="md"
        edsSubGridTabletGap="md"
      >
        <div class="ck-editor" *ngIf="articleHubInfo.summary?.value">
          <div [innerHTML]="articleHubInfo.summary?.value"></div>
        </div>
        <div
          *ngIf="articleHubInfo.imageSrc"
          edsFlexbox
          [justifyContent]="(isMobile$ | async) ? 'flex-start' : 'flex-end'"
          alignItems="center"
        >
          <eds-image [imgSrc]="articleHubInfo.imageSrc"></eds-image>
        </div>
      </div>
    </div>
    <div edsRow>
      <div edsCol>
        <ft-insights-library
          [externalTranslationLabel]="translationLabels"
          [hideLibraryHeader]="true"
          [preFilter]="articleHubInfo.articleFilters"
          [externalSIMLogoResource]="simLogoResourceBundle"
        ></ft-insights-library>
      </div>
    </div>
  </div>
</section>
